<i18n>
{
  "en": {
    "edit": "Edit link tree",
    "delete": "Delete link tree"
  },
  "es": {
    "edit":  "Editar arbol de links",
    "delete":  "Eliminar arbol de links"
  }
}
</i18n>
<template>
  <dynameat-row
    :title="linkTree.name"
    :button-config-list="buttonConfigList"
    :collapse-items="!$vuetify.breakpoint.mdAndUp"
    @editLinkTree="onEditLinkTree"
    @deleteLinkTree="onDeleteLinkTree"
    :isClickable="false"
  >
  </dynameat-row>
</template>
<script>
import DynameatRow from '@dynameat/components/DynameatRow';
import Component from 'vue-class-component';
import { Components } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { LinkTree } from '../models';

@Component
@Components({ DynameatRow })
export default class LinkTreeRow extends Vue {
  @Prop({
    Object,
    validator(linkTree) {
      return linkTree instanceof LinkTree;
    }
  }) linkTree;

  get buttonConfigList() {
    return [
      {
        title: this.$t('edit'),
        icon: 'mdi-pencil',
        emitName: 'editLinkTree',
      },
      {
        title: this.$t('delete'),
        icon: 'mdi-delete',
        emitName: 'deleteLinkTree',
      }
    ];
  }

  onEditLinkTree() {
    this.$emit('edit');
  }

  onDeleteLinkTree() {
    this.$emit('delete');
  }
}
</script>
